import React from 'react';

/** Skeleton card for community post feed */
export const CommunityPostSkeleton = () => (
  <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden animate-pulse" data-testid="skeleton-post">
    <div className="p-5">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-slate-200" />
        <div className="flex-1 space-y-2">
          <div className="h-3.5 bg-slate-200 rounded w-32" />
          <div className="h-3 bg-slate-200 rounded w-24" />
        </div>
        <div className="h-6 bg-slate-200 rounded-full w-20" />
      </div>
      <div className="space-y-2 mb-4">
        <div className="h-4 bg-slate-200 rounded w-full" />
        <div className="h-4 bg-slate-200 rounded w-5/6" />
        <div className="h-4 bg-slate-200 rounded w-2/3" />
      </div>
      <div className="flex items-center gap-4 pt-3 border-t border-slate-50">
        <div className="h-8 bg-slate-100 rounded-full w-16" />
        <div className="h-8 bg-slate-100 rounded-full w-20" />
        <div className="h-8 bg-slate-100 rounded-full w-14" />
      </div>
    </div>
  </div>
);

/** Skeleton cards for listing grid pages */
export const ListingSkeleton = () => (
  <div className="rounded-xl border bg-white overflow-hidden animate-pulse">
    <div className="h-48 bg-slate-200" />
    <div className="p-4 space-y-3">
      <div className="h-4 bg-slate-200 rounded w-1/4" />
      <div className="h-5 bg-slate-200 rounded w-3/4" />
      <div className="h-4 bg-slate-200 rounded w-1/2" />
      <div className="flex gap-2 pt-2">
        <div className="h-6 bg-slate-200 rounded-full w-16" />
        <div className="h-6 bg-slate-200 rounded-full w-20" />
      </div>
    </div>
  </div>
);

export const CommunityFeedSkeleton = ({ count = 4 }) => (
  <div className="space-y-4" data-testid="community-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <CommunityPostSkeleton key={i} />
    ))}
  </div>
);

/** Skeleton grid for listing pages (businesses, jobs, events) */
export const ListingGridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="listing-grid-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <ListingSkeleton key={i} />
    ))}
  </div>
);
